import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirlineSeatReclineNormalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airline_seat_recline_normal"}/>
}
